module.exports = __webpack_public_path__ + "static/media/bell.4a4df86a.svg";